import cx from 'classnames'
import { motion, useInView, useScroll, useTransform } from 'framer-motion'
import React, { ReactElement, useRef } from 'react'
import * as styles from '../../styles/components/content-blocks/video.module.scss'
import reactElementToString from '../../utils/react-element-to-string'
import { bezierEaseIn } from '../../utils/styles'
import CaptionText from '../caption-text'
import ContentWrapper from '../content-wrapper'
import SmallTitle from '../small-title'
import TypeWriter from '../typewriter'
import Video from '../video'
import { ContentBlockBase } from './shared'

export interface VideoBlockProps extends ContentBlockBase {
    title?: string
    caption?: ReactElement | string
    vimeoId?: string
    embedCode?: string
    altText?: string
}

const VideoBlock = (props: VideoBlockProps) => {
    const { title, caption, vimeoId, embedCode, altText, blockId } = props

    const targetRef = useRef<HTMLDivElement>(null)
    const { scrollYProgress } = useScroll({ target: targetRef, offset: ['start end', 'start start'] })
    const opacity = useTransform(scrollYProgress, [0.1, 0.7], [0, 1], { ease: bezierEaseIn })
    const hasBeenInView = useInView(targetRef, { margin: '-50%', once: true })

    return (
        <>
            <ContentWrapper className={cx(styles.container)}>
                <div
                    id={blockId}
                    ref={targetRef}
                    className={cx(styles.contentContainer)}
                >
                    {title &&
                        <SmallTitle className={cx(styles.title)} aria-label={title}>
                            <TypeWriter text={title} enabled={hasBeenInView} />
                        </SmallTitle>
                    }
                    {caption &&
                        <motion.div style={{ opacity }}>
                            <CaptionText
                                className={styles.caption}
                                dangerouslySetInnerHTML={{ __html: reactElementToString(caption) }}
                            />
                        </motion.div>
                    }
                    {(vimeoId || embedCode) &&
                        <motion.div className={cx(styles.videoContainer)} style={{ opacity }}>
                            <Video title={title} embedCode={embedCode} vimeoId={vimeoId} altText={altText}/>
                        </motion.div>
                    }
                </div>
            </ContentWrapper>
        </>
    )
}

export default VideoBlock
